<!-- 我的课程 -->

<template>
  <div class="main">
    <!-- 顶部搜索 -->
    <div class="s_wrapper">
      <el-input class="s_input" placeholder="搜索课程名称" suffix-icon="el-icon-search" v-model="courseName" :clearable="true"
        @change="onSearch"></el-input>
      <el-cascader :options="cascaderOptions" placeholder="选择分类" v-model="categoryIds" @change="onSearch"
        :props="cascaderprops" collapse-tags clearable></el-cascader>
    </div>
    <div class="globle_border" v-loading="loading">
      <!-- 表格 -->
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="210" show-overflow-tooltip prop="courseName" label="课程名称"></el-table-column>
          <el-table-column min-width="270" show-overflow-tooltip prop="categoryName" label="课程分类"></el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="price" label="课程价格(元)">
            <template slot-scope="scope">
              <span>{{ scope.row.costAttr == 0 ? '免费' : scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="effectiveDay" label="购买有效期">
            <template slot-scope="scope">
              <span v-if="scope.row.effectiveDay">{{ scope.row.effectiveDay }}</span>
              <span v-else>——</span>
            </template>
          </el-table-column>
          <el-table-column min-width="130" show-overflow-tooltip prop="buyerCount" label="购买人数"></el-table-column>
          <el-table-column min-width="150" show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
          <el-table-column label="是否推荐" header-align="center" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.recommendFlag == 1">是</span>
              <span v-if="scope.row.recommendFlag == 0">否</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
        layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      courseName: "",
      categoryIds: "",
      cascaderOptions: [],
      cascaderprops: {
        checkStrictly: false,
        emitPath: false,
        multiple: true,
        value: "id",
        label: "categoryName",
        children: "children",
      },
      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectCourseInfoPage();
    this.getCategoryList();
  },
  methods: {
    // 获取列表
    selectCourseInfoPage() {
      this.loading = true
      this.$axios
        .post(this.$api.selectCourseInfoPage, {
          categoryIdList: this.categoryIds.length == 0 ? null : this.categoryIds,
          courseName: this.courseName || null,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list.map(e => {
              return {
                ...e,
                switch: e.recommendFlag == 1 ? true : false
              }
            }) || []
            this.totalItemsCount = res.result.totalCount
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 分类选择
    getCategoryList() {
      this.$axios
        .get(this.$api.getCategoryListSelect)
        .then(res => {
          if (res.code == 100) {
            this.cascaderOptions = this.processCategoryData(res.result)
          }
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    processCategoryData(data) {
      function processItems(items, level) {
        for (let item of items) {
          if (level === 3) {
            delete item.children;
          } else if (item.children && item.children.length > 0) {
            processItems(item.children, level + 1);
          }
        }
      }
      const processedData = JSON.parse(JSON.stringify(data));
      processItems(processedData, 1); // 从第一层开始处理
      return processedData;
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.selectCourseInfoPage();
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.pageSize = e;
      this.onSearch();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.selectCourseInfoPage();
    },

  }

}
</script>

<style lang="scss" scoped>
.main {}
</style>
